import { z } from 'zod'

export const transferResponseSchema = z.object({
  id: z.string().guid(),
  amount: z.number(),
  convertedAmount: z.number(),
  conversionRate: z.number(),
  description: z.string().nullable(),
  date: z.string(),
  fromAccountId: z.string().guid(),
  toAccountId: z.string().guid(),
  fromAccountName: z.string(),
  fromAccountCurrency: z.string(),
  toAccountName: z.string(),
  toAccountCurrency: z.string(),
  userId: z.string().guid(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type TransferResponseDto = z.infer<typeof transferResponseSchema>
